import { Link } from "react-router-dom"

export default function NavItem(props: {
    href: string,
    label: string
}) {
    return (
        <Link to={props.href} className="px-8 py-4 text-neutral-8 text-[20px] w-max hover:text-white hover:bg-primary hover:cursor-pointer">{props.label}</Link>
    )
}